import { Tag, TagColorType } from "components/DesignSystem/Tag/Tag";
import {
  INVOICE_SOURCE_SYNC_STATUS,
  SOURCE_SYNC_TAG_LABEL,
} from "constants/invoiceSourceSync";
import { InvoiceSourceSync } from "types/Models/invoiceSourceSync";

type InvoiceSyncTagProps = {
  sourceSync?: InvoiceSourceSync | null;
};

const TAG_COLOR: Record<keyof typeof SOURCE_SYNC_TAG_LABEL, TagColorType> = {
  [INVOICE_SOURCE_SYNC_STATUS.CHANGED]: "orange",
  [INVOICE_SOURCE_SYNC_STATUS.NEEDS_REVIEW]: "red",
  [INVOICE_SOURCE_SYNC_STATUS.VOIDED_SOURCE_DELETED]: "gray",
};

const isTaggedStatus = (
  status: InvoiceSourceSync["status"]
): status is keyof typeof SOURCE_SYNC_TAG_LABEL =>
  status in SOURCE_SYNC_TAG_LABEL;

export const InvoiceSyncTag = ({ sourceSync }: InvoiceSyncTagProps) => {
  if (!sourceSync || !isTaggedStatus(sourceSync.status)) {
    return null;
  }

  return (
    <Tag size="small" rounded tagType={TAG_COLOR[sourceSync.status]}>
      {SOURCE_SYNC_TAG_LABEL[sourceSync.status]}
    </Tag>
  );
};
